<template>
  <div class="flex flex-col items-start">
    <NText variant="caption1" class="whitespace-pre-line">
      {{ t('orders.symbolUnderCautionDescription') }}
    </NText>

    <a target="_blank" href="/docs/petrochemicals-caution.pdf">
      <NButton
        size="mini"
        variant="flat"
        color="gray"
        class="mt-2 !rounded-full"
      >
        <NegarDownloadIcon
          size="16"
          class="text-neutral-secondary mx-auto cursor-pointer ml-1"
        />

        <NText
          variant="overline"
          weight="medium"
          class="text-neutral-secondary"
        >
          {{ t('agreement.downloadAgreementText') }}
        </NText>
      </NButton>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NegarDownloadIcon } from '@negar/icons';

const { t } = useI18n();
</script>
